interface InitialOption {
  label: string;
  value: string | number;
}

export interface Initial {
  //add other initial types a required as a union type (|) currently tbd
  (value: any): InitialOption | undefined;
}

export const initialiseUserOption: Initial = ({ user } = {}) => {
  const { full_name, pay_level, id: value } = user ?? {};
  if (!full_name || !value) return;
  return { label: `${full_name} ${pay_level?.name && `(${pay_level.name})`}`, value };
};

export const initialise: (key: string) => Initial = (key) => {
  return (props = {}) => {
    const { name: label, id: value } = props[key] ?? [];
    if (!label || !value) return;
    return { label, value };
  };
};
